import type { ReactNode } from 'react'

import { Button, type ButtonProps } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export type PageHeaderActionsProps = {
  /** Icon-only utilities (`ghostToolbar` / domain icon buttons). */
  tertiary?: ReactNode
  /** Outlined commands (Share menu, Invite, view+copy bundles). */
  secondary?: ReactNode
  /** Brand primary CTAs and lifecycle split buttons. */
  primary?: ReactNode
  className?: string
}

/** Right-side agent-shell page toolbar — tertiary → secondary → primary. */
export function PageHeaderActions({
  tertiary,
  secondary,
  primary,
  className,
}: PageHeaderActionsProps) {
  if (!tertiary && !secondary && !primary) {
    return null
  }

  return (
    <div className={cn('flex flex-wrap items-center justify-end gap-2', className)}>
      {tertiary}
      {secondary}
      {primary}
    </div>
  )
}

export function PageHeaderActionPrimary({ className, ...props }: ButtonProps) {
  return (
    <Button
      type="button"
      variant="default"
      size="sm"
      className={cn('gap-2', className)}
      {...props}
    />
  )
}

export function PageHeaderActionSecondary({ className, ...props }: ButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn('gap-2', className)}
      {...props}
    />
  )
}

export function PageHeaderActionTertiary({ className, ...props }: ButtonProps) {
  return (
    <Button
      type="button"
      variant="ghostToolbar"
      size="iconSm"
      className={className}
      {...props}
    />
  )
}
